import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Avatar } from 'primereact/avatar'

const NotFound: React.FC = () => {
    const navigate = useNavigate()

    const handleGoHome = () => {
        navigate('/')
    }

    const handleGoBack = () => {
        navigate(-1)
    }

    const helpfulLinks = [
        {
            title: 'Homepage',
            description: 'Return to the main page',
            icon: 'pi pi-home',
            action: handleGoHome
        },
        {
            title: 'Latest News',
            description: 'Stay updated with Tamil community news',
            icon: 'pi pi-book',
            action: () => navigate('/#news')
        },
        {
            title: 'Obituaries',
            description: 'Remember our loved ones',
            icon: 'pi pi-users',
            action: () => navigate('/obituaries')
        },
        {
            title: 'Tamil Shops',
            description: 'Discover local businesses',
            icon: 'pi pi-shopping-bag',
            action: () => navigate('/shops')
        }
    ]

    return (
        <div className="min-h-screen flex align-items-center justify-content-center p-4 surface-ground">
            <div className="flex flex-column align-items-center w-full max-w-60rem">
                {/* 404 Header */}
                <div className="text-center mb-6">
                    <h1
                        className="text-8xl font-black mb-0"
                        style={{
                            background: 'linear-gradient(135deg, #d35400 0%, #1a252f 100%)',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            fontFamily: 'serif'
                        }}
                    >
                        404
                    </h1>
                    <h2 className="text-4xl font-bold mb-3 text-900 font-serif">
                        Page Not Found
                    </h2>
                    <p className="text-600 text-xl max-w-30rem mx-auto line-height-3">
                        The page you are looking for does not exist or has been moved.
                        Please check the URL or use the navigation to find what you are looking for.
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-column sm:flex-row gap-3 w-full max-w-30rem mb-8">
                    <Button
                        label="Go to Homepage"
                        icon="pi pi-home"
                        onClick={handleGoHome}
                        className="p-button-lg flex-1 font-bold"
                        style={{ background: 'linear-gradient(135deg, #d35400 0%, #1a252f 100%)', border: 'none' }}
                    />
                    <Button
                        label="Go Back"
                        icon="pi pi-arrow-left"
                        onClick={handleGoBack}
                        className="p-button-lg p-button-outlined flex-1 font-bold"
                        style={{ color: '#d35400', borderColor: '#d35400' }}
                    />
                </div>

                {/* Helpful Links */}
                <div className="w-full mb-6">
                    <h3 className="text-2xl font-bold text-center mb-4 text-900 font-serif">Helpful Links</h3>
                    <div className="grid">
                        {helpfulLinks.map((link, index) => (
                            <div className="col-12 md:col-6 lg:col-3" key={index}>
                                <div
                                    className="surface-card p-4 border-round-xl shadow-2 cursor-pointer transition-all transition-duration-300 hover:shadow-6 hover:-translate-y-2 h-full border-1 border-transparent hover:border-orange-500"
                                    onClick={link.action}
                                >
                                    <div className="text-center">
                                        <div
                                            className="inline-flex align-items-center justify-content-center border-circle mb-3"
                                            style={{
                                                width: '60px',
                                                height: '60px',
                                                background: 'rgba(211, 84, 0, 0.1)',
                                                color: '#d35400'
                                            }}
                                        >
                                            <i className={`${link.icon} text-2xl`}></i>
                                        </div>
                                        <div className="text-xl font-bold mb-2 text-900 font-serif">{link.title}</div>
                                        <div className="text-600 line-height-3 text-sm">{link.description}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Support Information */}
                <div className="surface-card p-4 border-round-xl shadow-2 w-full max-w-30rem border-top-3 border-orange-500">
                    <div className="flex align-items-center justify-content-center gap-4">
                        <Avatar icon="pi pi-question" size="large" className="bg-orange-100 text-orange-500" shape="circle" />
                        <div>
                            <div className="text-lg font-bold mb-1 text-900">Need Help?</div>
                            <p className="text-600 m-0 mb-2 text-sm">
                                If you continue to have problems or have questions, please feel free to contact us.
                            </p>
                            <Button
                                label="Contact Support"
                                icon="pi pi-envelope"
                                className="p-button-text p-button-sm p-0 text-orange-600 hover:text-orange-700"
                                onClick={() => window.open('mailto:info@yarlhub.com')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound
